// src/components/MaintenanceTaskModal.jsx
import { useState } from "react";
import { Button, Divider, Modal, CardContent, Stack } from "@mui/material";
import { LoadingButton } from '@mui/lab';

import MainCard from "components/MainCard";
import { useMaintenanceForm } from "./useMaintenanceForm";
import MaintenanceCommonForm from "./MaintenanceCommonForm";
import { useTranslation } from "react-i18next";
import PermissionButton from "components/PermissionButton";
import { PERMISSIONS } from "config/permissions";

const MaintenanceTaskModal = ({ id, onRefresh, type }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  // 🚀 훅에 필수 정보와 성공 시 모달을 닫는 handleClose 전달
  const mForm = useMaintenanceForm({ id, onRefresh, type, handleCloseModal: handleClose });

  return (
    <>
      <PermissionButton
          permission={PERMISSIONS.MAINTENANCE_TASK_WRITE}
          variant="contained" style={{ border: "1px solid #02db02", color: "#fff", marginLeft:"3px", marginRight:"3px" }} onClick={handleOpen}
      >
          {t('message.common.btn.management.maintenance')}
      </PermissionButton>

      <Modal className="pop_box pop_box1 renew_pop_box" open={open} onClose={handleClose}>
        <MainCard modal darkTitle content={false} sx={{ width: 800 }}>
          <div className="modal-header">🚨 {t('message.common.btn.management.maintenance')}</div>

          <CardContent sx={{ maxHeight: "70vh", overflowY: "auto" }}>
            {/* 🚀 mForm.onFormSubmit 연결 */}
            <form onSubmit={mForm.handleSubmit(mForm.onFormSubmit)}>
              
              <MaintenanceCommonForm mForm={mForm} />

              <Divider />

              {/* 하단 풋터 단추 영역 */}
              <Stack direction="row" justifyContent="flex-end" spacing={1} sx={{ p: 2 }}>
                {((mForm.type && mForm.type === "modify" && mForm.maintenanceTask?.workingBgnAt) || (!mForm.maintenanceTask?.workingBgnAt)) && (
                  <LoadingButton variant="contained" size="small" color="primary" loading={mForm.fileLoading} type="submit">
                    {(mForm.type === "modify" && mForm.maintenanceTask?.workingBgnAt) ? t('message.common.btn.modify') : t('message.common.btn.write')}
                  </LoadingButton>
                )}
                <Button variant="contained" onClick={handleClose} color="inherit">{t('message.common.btn.cancel')}</Button>
              </Stack>

            </form>
          </CardContent>
        </MainCard>
      </Modal>
    </>
  );
};

export default MaintenanceTaskModal;